"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Validation_1 = __importDefault(require("../../../../../Validation"));
var lodash_1 = require("lodash");
var react_i18next_1 = require("react-i18next");
var BlInput_1 = __importDefault(require("../../../../../FormComponents/BlInput"));
var Icon_1 = __importDefault(require("../../../../../Icon"));
var react_redux_1 = require("react-redux");
var settingsSlice_1 = require("../../../../../../features/settings/settingsSlice");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../../../styles.module.scss"));
var ProjectsName = function (_a) {
    var formikProps = _a.formikProps;
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation('common').t;
    var addNewProject = react_1.useCallback(function () {
        if (formikProps.values.projects[formikProps.values.projects.length - 1]
            .name) {
            formikProps.setFieldValue('projects', __spreadArray(__spreadArray([], formikProps.values.projects), [
                {
                    id: lodash_1.uniqueId(),
                    name: '',
                },
            ]));
        }
    }, [formikProps.values.projects]);
    var onChange = react_1.useCallback(function (value, id) {
        var findIndex = formikProps.values.projects.findIndex(function (item) { return item.id === id; });
        formikProps.setFieldValue("projects[" + [findIndex] + "].name", value);
    }, [formikProps.values.projects]);
    var removeProject = react_1.useCallback(function (id) {
        var filterElement = formikProps.values.projects.filter(function (item) { return item.id !== id; });
        formikProps.setFieldValue('projects', filterElement);
        dispatch(settingsSlice_1.removeDeveloperProject(id));
    }, [formikProps.values.projects]);
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.row, 'eight wide computer column') },
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.section_field) },
            react_1.default.createElement("label", { className: styles_module_scss_1.default.label_inputs, htmlFor: "projectName" },
                react_1.default.createElement("p", null, t('Account.Settings.DONE_PROJECTS')),
                react_1.default.createElement("p", { className: styles_module_scss_1.default.sub_label },
                    "(",
                    t('Account.Settings.PROJECT_ADDRESS'),
                    ")"),
                formikProps.values.projects.map(function (item, index) {
                    var _a;
                    return (react_1.default.createElement(Validation_1.default, { key: index, name: "projectName", formikProps: formikProps },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(BlInput_1.default, { type: "text", onChange: function (event) {
                                    return onChange(event.target.value, item.id);
                                }, value: (_a = item.name) !== null && _a !== void 0 ? _a : '', element: index && item.name ? (react_1.default.createElement("div", { onClick: function () {
                                        return removeProject(item.id);
                                    }, className: styles_module_scss_1.default.minus_icon },
                                    react_1.default.createElement(Icon_1.default, { name: "minus circle icon" }))) : null }))));
                }))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.add_new_project, onClick: addNewProject },
            react_1.default.createElement(Icon_1.default, { name: "plus circle icon" }))));
};
exports.default = ProjectsName;
